// 搜索框类型
export const SEARCH_BOX_TYPE = {
  NORMAL_INPUT: 'normalInput',
  SELECT_INPUT: 'selectInput',
  SELECT: 'select',
  DATE_SELECT: 'dateSelect',
  MULTIPLE_COL_SELECT: 'multipleColSelect',
  AREA: 'area',
  FILTER: 'filter',
  RESET: 'reset',
  EXPORT: 'export',
  EXTRA: 'extra',
}
// 筛选面板框类型
export const FILTER_PANEL_OPT_TYPE = {
  DATE: 'date',
  AREA: 'area', // 暂时不支持，业务暂不需要
}
// 时间格式
export const DATE_TYPE = {
  DATE: 'date',
  DATETIME: 'datetime',
  // TIME: 'time',
  YEAR_MONTH: 'year-month',
  DATE_SECOND: 'date-second',
  // MONTH_DAY: 'month-day',
  // DATE_HOUR: 'datehour',
}
// 输入框类型
export const INPUT_TYPE = {
  TEXT: 'text',
  NUMBER: 'number',
}

// 自定义日期
export const OTHER_TYPE = {
  CUSTOM_DATE: 'customDate',
}
